// Datos base de identidad y navegación del sitio.

import { listarAsociaciones } from "@/services/asociaciones/asociacionesService";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export async function getHeroData() {
  await delay(50);
  return {
    title: "Todo empieza con un lanzamiento",
    hashtag: "#UnaPasiónQueNosUne",
    ctas: [
      { label: "Próximas Fechas", href: "#próximas-fechas" },
      { label: "Reglamentos", href: "/la-federacion#reglamentacion" },
      { label: "La Federación", href: "/la-federacion" },
    ],
  };
}

export function createCommunityFallback() {
  return {
    stats: [
      { icon: "location", value: 28, label: "Asociaciones" },
      { icon: "building", value: 224, label: "Clubes" },
      { icon: "users", value: "6.000", label: "Jugadores" },
    ],
    cities: [],
  };
}

export async function getCommunityStats() {
  const [asociacionesRes] = await Promise.allSettled([listarAsociaciones()]);
  const asociaciones =
    asociacionesRes.status === "fulfilled"
      ? asociacionesRes.value?.items || []
      : [];
  const asociacionesTotal =
    asociacionesRes.status === "fulfilled"
      ? Number(asociacionesRes.value?.total ?? asociaciones.length)
      : 28;

  const stats = [
    {
      icon: "location",
      value: asociacionesTotal > 0 ? asociacionesTotal : 28,
      label: "Asociaciones",
    },
    {
      icon: "building",
      value: 224,
      label: "Clubes",
    },
    {
      icon: "users",
      value: "6.000",
      label: "Jugadores",
    },
  ];

  return {
    stats,
    cities: [],
  };
}

export function createFooterFallback() {
  return {
    about: {
      title: "Federación de Bochas Córdoba",
      description:
        "Promoviendo el deporte de bochas en toda la provincia de Córdoba desde 1967.",
    },
    quickLinks: [
      { label: "Torneos", to: "/calendario" },
      { label: "Resultados", to: "/resultados" },
      { label: "Calendario", to: "/calendario" },
      { label: "Noticias", to: "/noticias" },
    ],
    institutional: [
      {
        label: "Reglamento Sudamericano",
        icon: "doc",
        to: "/la-federacion#reglamentacion",
      },
      {
        label: "Código de Penas",
        icon: "doc",
        to: "/la-federacion#reglamentacion",
      },
      {
        label: "Libro de Métodos",
        icon: "doc",
        to: "/la-federacion#reglamentacion",
      },
      { label: "Estatuto", icon: "doc", to: "/la-federacion#reglamentacion" },
    ],
    contact: {
      address: "Bulnes 1548, Córdoba Capital, Argentina",
      phone:
        "+54 9 3562 45-7110\n+54 9 3584 30-0876\n+54 9 3564 61-7576\n+54 9 3515 21-1782",
      email: "federacionbochascordoba67@gmail.com",
    },
  };
}

export async function getFooterData() {
  await delay(50);
  return createFooterFallback();
}
